<div *ngIf="formGroup && placeInForm" xmlns="http://www.w3.org/1999/html">
  <section>
    <app-grid-registration-connection-info [model]="model"></app-grid-registration-connection-info>
    <h2>Installierte Leistung</h2>

    <app-default-card
      [title]="'Netzanmeldung'"
      [hideInfoWrapper]="true"
      [info]="'Die hier angegebenen Informationen stammen aus Ihrem Netzanschlussbegehren'">
      <form-row>
        <strong>Installierte Modulleistung (kWp):</strong>
        {{ model.newInstalledPower | number : undefined : 'de-DE' }} kWp
      </form-row>

      <form-row>
        <strong>Maximale Scheinleistung (kVA):</strong>
        {{ model.newProduction | number : undefined : 'de-DE' }} kVA
      </form-row>
    </app-default-card>

    <app-default-card
      [title]="'Verbaute Komponenten'"
      [error]="
        producers?.status === 'INVALID' ||
        (model.powerGenerationSource === PowerGenerationSourceEnum.PhotoVoltaic &&
          pvModules?.status === 'INVALID') ||
        storages?.status === 'INVALID' ||
        consumers?.status === 'INVALID' ||
        formGroup.errors?.thresholdExceeded
      "
      [errorMessage]="
        formGroup.errors?.thresholdExceeded
          ? ('gr_power_thresholdExceededMessage' | uiAdaptionValue) ||
            'Die Summe der installierten Leistung übersteigt die von Ihnen angemeldete. Bitte wenden Sie sich an Ihren Ansprechpartner.'
          : 'Bitte überprüfen Sie die eingegebenen Daten.'
      "
      [hideInfoWrapper]="true"
      [info]="'Bitte geben Sie uns hier Informationen zu den tatsächlich verbauten Komponenten an.'">
      <h2>Erzeugungseinheiten:</h2>
      <section>
        <app-grid-registration-producer-v2
          [inputFormArray]="producers"
          [gridRegistration]="this.model"></app-grid-registration-producer-v2>
        <app-hint-card *ngIf="hasMastrMismatchField('newProduction')" [type]="'danger'">
          Die AC-maximale Wirkleistung (gesamt) stimmt nicht mit der Angabe im Markt-Stammdatenregister
          überein.
        </app-hint-card>
      </section>
      <section *ngIf="model.powerGenerationSource === PowerGenerationSourceEnum.PhotoVoltaic">
        <h2>PV-Module:</h2>
        <app-grid-registration-pv-module-v2
          [inputFormArray]="pvModules"
          [requireOne]="true"></app-grid-registration-pv-module-v2>
        <app-hint-card *ngIf="hasMastrMismatchField('pvModules')" [type]="'danger'">
          Die Anzahl der Module stimmt nicht mit der Angabe im Markt-Stammdatenregister überein
        </app-hint-card>
        <app-hint-card *ngIf="hasMastrMismatchField('newInstalledPower')" [type]="'danger'">
          Die Gesamtleistung der PV-Module stimmt nicht mit der Angabe im Markt-Stammdatenregister überein.
        </app-hint-card>
      </section>
      <section *ngIf="firstStorage && firstConsumer">
        <h2>Speicher:</h2>
        <app-grid-registration-storage-v2 [formGroup]="firstStorage"></app-grid-registration-storage-v2>
        <form-row>
          <mat-form-field fxFlex="50" appearance="outline">
            <mat-label>Leistung (kW)</mat-label>
            <input matInput type="number" min="0" [formControl]="firstConsumer?.controls['power']" />
            <mat-hint>Leistung (kW) pro Speicher</mat-hint>
          </mat-form-field>
        </form-row>
        <mat-error *ngIf="firstConsumer?.errors?.powerExceeded || firstConsumer?.errors?.powerDeceeded">
          In Ihrer Inbetriebnahme haben Sie die Grenze entgegen der angemeldeten Bezugsleistung für Ihren
          Speicher {{ firstConsumer?.errors?.powerExceeded ? 'überschritten' : 'unterschritten' }}. Bitte
          nehmen Sie Kontakt zu uns auf um das weitere Vorgehen abzustimmen.
        </mat-error>
        <p>
          <strong>
            Gesamtwechselrichterleistung der Speicher:
            {{ totalConsumerStoragePower$ | async | number : undefined : 'de-DE' }}
            kW
          </strong>
        </p>
      </section>
    </app-default-card>

    <!--<app-default-card [title]="'Einspeisemanagement'" *ngIf="showFeedInManagement$ | async">
      <form-row>
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Seriennummer des Einspeisemanagements</mat-label>
          <input matInput type="text" [formControl]="formGroup.controls.feedInManagementSerialNumber" />
        </mat-form-field>
      </form-row>
    </app-default-card>-->

    <ng-container *ngIf="!model?.disableMastrValidation">
      <app-tenant-config-proxy
        [configPath]="'gridRegistration.mastrValidationConfig.enableMastrValidationForPlaceInServiceRequest'">
        <ng-template #proxyContent>
          <app-default-card
            [title]="'Validierung der Angaben im Marktstammdatenregister'"
            [error]="hasMastrDataFieldMismatch()"
            [errorMessage]="
              'Die Angaben im Marktstammdatenregister stimmen nicht mit den hier gemachten Angaben überein. Bitte korrigieren Sie die rot markierten Felder.'
            "
            [hideInfoWrapper]="true"
            [info]="
              'Überprüfen Sie hier die Angaben aus dem Marktstammdatenregister mit den Angaben im Inbetriebsetzungsprotokoll. Gelb markierte Zeilen stimmen nicht überein, sind aber optional zu korrigieren. Rot markierte Felder stimmen nicht überein und müssen zum Abschicken des Inbetriebsetzungsprotokolls korrigiert werden'
            ">
            <ng-container *ngIf="mastrHintUIAdaptionName | uiAdaptionVisible$ | async">
              <app-hint-card [type]="'info'" [outlined]="true">
                <div [innerHTML]="mastrHintUIAdaptionName | uiAdaptionValue | safeHtmlPipe"></div>
              </app-hint-card>
              <div style="margin-bottom: 2rem"></div>
            </ng-container>
            <form-row *ngIf="formGroup.controls.maStRNumberProducer as maStRNumberProducer">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>MaStR-Nummern der Erzeugungseinheiten</mat-label>
                <input
                  matInput
                  type="text"
                  [formControl]="maStRNumberProducer"
                  (input)="maStRNumberProducer.setValue(maStRNumberProducer.value.toUpperCase())" />
                <mat-error *ngIf="maStRNumberProducer.hasError('required')">
                  Das Feld ist erforderlich
                </mat-error>
                <mat-error *ngIf="maStRNumberProducer.hasError('pattern')">
                  MaStR-Nummern der Erzeugungseinheiten besteht aus „SEE9“ plus 11 Ziffern
                </mat-error>
                <mat-hint>
                  Die Markt-Stammdatenregister-Nummer der Erzeugungseinheit, die dieser Netzanmeldung
                  unterliegt (beginnend mit "SEE9", gefolgt von 10 Ziffern und einer abschließenden
                  Prüfziffer)
                </mat-hint>
              </mat-form-field>
            </form-row>
            <h2>Vergleichstabelle Marktstammdatenregister</h2>
            <app-mastr-validation
              [grData]="modelAndFormValue$ | async"
              [companyLocationExternalId]="model?.companyLocation?.external_id"
              [mastrNumber]="(formValue$ | async).maStRNumberProducer"
              (mastrDataMismatchFields)="setMastrMismatchFields($event)"
              (mastrDataFetch)="updateFormWithMastrData($event)" />
            <div style="margin-top: 2rem">
              <form-row>
                <mat-form-field appearance="outline">
                  <mat-label>Datum der Registrierung</mat-label>
                  <input
                    matInput
                    [formControl]="formGroup.controls.maStRRegistrationDate"
                    [matDatepicker]="register" />
                  <mat-datepicker-toggle matSuffix [for]="register"></mat-datepicker-toggle>
                  <mat-datepicker #register></mat-datepicker>
                </mat-form-field>
              </form-row>
            </div>
            <form-row *ngIf="formGroup.controls.maStREEGNumber as maStREEGNumber">
              <mat-form-field appearance="outline" fxFlex>
                <mat-label>EEG-MaStR-Nummer der Erzeugungsanlage</mat-label>
                <input matInput type="text" [formControl]="maStREEGNumber" />
                <mat-hint>Diese Angabe wird automatisch ermittelt</mat-hint>
              </mat-form-field>
            </form-row>
            <section>
              <h3>Datum der EEG-Technischen Inbetriebnahme</h3>
              <form-row>
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>Datum der Inbetriebnahme</mat-label>
                  <input
                    matInput
                    [formControl]="formGroup.controls.placeInService.controls.placeInServiceDatum"
                    [matDatepicker]="placeInServiceDatum" />
                  <mat-datepicker-toggle matSuffix [for]="placeInServiceDatum"></mat-datepicker-toggle>
                  <mat-datepicker #placeInServiceDatum></mat-datepicker>
                  <mat-error
                    *ngIf="
                      placeInForm.get('placeInServiceDatum').hasError('required') &&
                      placeInForm.get('placeInServiceDatum').touched
                    ">
                    {{ errorFieldRequired }}
                  </mat-error>
                  <mat-hint
                    *ngIf="placeInServiceDatumMastrWarning$ | async as mastrDatumWarning"
                    class="text-warning gr-place-in-service-datum-mastr-warning">
                    {{ mastrDatumWarning }}
                  </mat-hint>
                </mat-form-field>
              </form-row>
            </section>
            <section
              *ngIf="
                storageMaStRDisplayData.registerDate ||
                storageMaStRDisplayData.inbetriebnahmeDatum ||
                formGroup.controls.maStRNumberStorage.value
              ">
              <h3>Angaben zum Speicher</h3>
              <p *ngIf="storageMaStRDisplayData.registerDate">
                <em>Registrierungsdatum:</em>
                {{ storageMaStRDisplayData.registerDate | date : 'shortDate' }}
              </p>
              <p *ngIf="storageMaStRDisplayData.inbetriebnahmeDatum">
                <em>Inbetriebnahmedatum:</em>
                {{ storageMaStRDisplayData.inbetriebnahmeDatum | date : 'shortDate' }}
              </p>
              <form-row *ngIf="formGroup.controls.maStRNumberStorage.value">
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>MaStR-Nummer des Speichers</mat-label>
                  <input matInput type="text" [formControl]="formGroup.controls.maStRNumberStorage" />
                  <mat-hint>Diese Angabe wird automatisch ermittelt</mat-hint>
                </mat-form-field>
              </form-row>
            </section>
          </app-default-card>
        </ng-template>
      </app-tenant-config-proxy>
    </ng-container>

    <app-default-card
      [title]="'Messkonzept'"
      [hideInfoWrapper]="true"
      [info]="'Bitte wählen Sie hier das von Ihnen geplante Messkonzept aus.'"
      [error]="!formGroup.get('meteringConcept').valid">
      <app-grid-registration-metering-concept-v2
        [disable]="false"
        [control]="meteringConcept"></app-grid-registration-metering-concept-v2>
      <form-row>
        <mat-error *ngIf="!meteringConcept.valid">Bitte wählen Sie ein Messkonzept aus.</mat-error>
      </form-row>
    </app-default-card>

    <app-default-card [title]="'Dokumente'" [hideInfoWrapper]="true" [info]="''">
      <app-upload-documents
        [inputFormArray]="uploads"
        [documentTag]="'uploads'"
        [showTag]="false"
        [canUpdate]="true"
        [filterCriteria]="'equal'"
        [numberOfUploads]="10"
        [editUpload]="true"
        [showUploadButton]="true">
        <div>
          <ng-container
            *ngIf="documentsUploadInfoUIAdaptionName | uiAdaptionVisible; else defaultTechnicalDocumentsInfo">
            <div [innerHTML]="documentsUploadInfoUIAdaptionName | uiAdaptionValue | safeHtmlPipe"></div>
          </ng-container>
          <ng-template #defaultTechnicalDocumentsInfo>
            <p>
              Relevante technische Dokumentationen.
              <br />
              z.B. Datenblätter der verbauten Komponenten, Zertifikate und einen einpoligen
              Übersichtsschaltplan.
              <br />
            </p>
          </ng-template>
        </div>
      </app-upload-documents>
    </app-default-card>

    <app-gr-meter-formpart
      [formGroup]="formGroup"
      [hasDefiniteMeter]="model.feedingPlantType == FeedingPlantTypeEnum.Extension" />
  </section>

  <!-- TODO: Umbiegen 4105 / 4110 - Benötigte Felder ändern -->
  <app-default-card
    *ngIf="feederConnectionStandard !== FeederConnectionStandard.VDE4110"
    [title]="'VDE 4105 Checkliste'"
    [hideInfoWrapper]="true"
    [info]="''">
    <form [formGroup]="placeInForm" formFocusable>
      <section>
        <form-row>
          <mat-checkbox formControlName="effectiveAndRequestedValuesMatch">
            Übereinstimmung der Daten aus dem Antrag zur Netzanmeldung mit dem Anlagenaufbau?
            <mat-error
              *ngIf="
                !placeInForm.get('effectiveAndRequestedValuesMatch').valid &&
                placeInForm.get('effectiveAndRequestedValuesMatch').touched
              ">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>

        <form-row>
          <mat-checkbox formControlName="invoiceMeteringCheckDone">
            Abrechnungsmessung - Vorinbetriebsetzungsprüfung + Inbetriebsetzungsprüfung erfolgt?
            <mat-error
              *ngIf="
                !placeInForm.get('invoiceMeteringCheckDone').valid &&
                placeInForm.get('invoiceMeteringCheckDone').touched
              ">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>

        <form-row>
          <mat-checkbox formControlName="vdeCertificateExists">
            Einheitenzertifikat für Erzeugungseinheiten und/oder Speicher (soweit jeweils in der Kundenanlage
            verbaut) vorhanden (siehe Vordruck E.4) bzw. nach VDE-AR-N 4110?
            <mat-error
              *ngIf="
                !placeInForm.get('vdeCertificateExists').valid &&
                placeInForm.get('vdeCertificateExists').touched
              ">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>

        <form-row>
          <mat-checkbox formControlName="powerDirectionSensorCheckDone">
            Energieflussrichtungssensor - Funktionstest durch Errichter durchgeführt und bestanden?
            <mat-error
              *ngIf="
                !placeInForm.get('powerDirectionSensorCheckDone').valid &&
                placeInForm.get('powerDirectionSensorCheckDone').touched
              ">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>

        <div class="group">
          <label id="regulator">
            Soweit im jeweiligen Anschlussfall erforderlich: Zertifikat für die Leistungsflussüberwachung am
            Netzanschlusspunkt (P
            <sub>AV, E</sub>
            - Überwachung, Symmetrieeinrichtung nach VDE-AR-N 4100, 5.5)?
            <mat-error
              *ngIf="
                !placeInForm.get('vdeArN4100_55_CertificateExists').valid &&
                placeInForm.get('vdeArN4100_55_CertificateExists').touched
              ">
              {{ errorOptionRequired }}
            </mat-error>
          </label>

          <form-row>
            <mat-radio-group
              aria-labelledby="regulator"
              class="radio-group"
              fxLayout="row"
              fxLayoutGap="2em"
              formControlName="vdeArN4100_55_CertificateExists">
              <mat-radio-button class="radio-button" [value]="true">Vorhanden</mat-radio-button>
              <mat-radio-button class="radio-button" [value]="false">Nicht erforderlich</mat-radio-button>
            </mat-radio-group>
          </form-row>
        </div>

        <form-row>
          <mat-checkbox formControlName="powerProtectionCertificateExists">
            Zertifikat für den NA-Schutz vorhanden (siehe Vordruck E.6)?
            <mat-error
              *ngIf="
                !placeInForm.get('powerProtectionCertificateExists').valid &&
                placeInForm.get('powerProtectionCertificateExists').touched
              ">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>

        <form-row>
          <mat-checkbox formControlName="factorCosphiCheck">
            Verfahren zur Blindleistungsbereitstellung:
            {{
              model.reactivePowerProvisioningMethod
                | appDisplayName : (this.metaService.reactivePowerProvisioningMethods$ | async)
            }}
            eingestellt?
            <mat-error
              *ngIf="
                !placeInForm.get('factorCosphiCheck').valid && placeInForm.get('factorCosphiCheck').touched
              ">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>
        <app-hint-card
          [outlined]="true"
          [type]="'warning'"
          *ngIf="
            'gridRegistration.placeInServiceRequest.vdeChecklistFactorCosphiCheckHint'
              | uiAdaptionVisible$
              | async
          ">
          <div
            [innerHTML]="
              'gridRegistration.placeInServiceRequest.vdeChecklistFactorCosphiCheckHint'
                | uiAdaptionValue
                | safeHtmlPipe
            "></div>
        </app-hint-card>
      </section>
      <section>
        <h2>NA-Schutz</h2>
        <div class="group">
          <form-row>
            <label id="naProtection">Art des NA-Schutzes:</label>
            <mat-error
              *ngIf="!placeInForm.get('naProtection').valid && placeInForm.get('naProtection').touched">
              {{ errorOptionRequired }}
            </mat-error>
          </form-row>
          <form-row>
            <mat-radio-group
              aria-labelledby="naProtection"
              class="radio-group"
              fxLayout="row"
              fxLayoutGap="2em"
              formControlName="naProtection"
              (change)="setValidatorsNaProtection()">
              <mat-radio-button class="radio-button" [value]="naProtectionTypeEnum.Integrated">
                Integriert
              </mat-radio-button>
              <mat-radio-button class="radio-button" [value]="naProtectionTypeEnum.Centralised">
                Zentral
              </mat-radio-button>
            </mat-radio-group>
          </form-row>
        </div>

        <form-row>
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Eingestellter Wert des Spannungssteigerungsschutz in V</mat-label>
            <input matInput type="number" formControlName="overvoltageProtectionType" />
          </mat-form-field>
        </form-row>

        <div
          *ngIf="
            placeInForm.get('naProtection') &&
            placeInForm.get('naProtection').value == naProtectionTypeEnum.Centralised
          ">
          <form-row>
            <mat-checkbox formControlName="overvoltageReleaseTestDone">
              Auslösetest "Zentraler NA-Schutz - Kuppelschalter" erfolgreich durchgeführt?
              <mat-error
                *ngIf="
                  !placeInForm.get('overvoltageReleaseTestDone').valid &&
                  placeInForm.get('overvoltageReleaseTestDone').touched
                ">
                {{ errorCheckRequired }}
              </mat-error>
            </mat-checkbox>
          </form-row>
          <form-row>
            <mat-checkbox formControlName="triggerCircuitTestDone">
              Auslösekreises "Zentraler NA-Schutz - Kuppelschalter" nach Ruhestromprinzip ausgeführt und
              geprüft?
              <mat-error
                *ngIf="
                  !placeInForm.get('triggerCircuitTestDone').valid &&
                  placeInForm.get('triggerCircuitTestDone').touched
                ">
                {{ errorCheckRequired }}
              </mat-error>
            </mat-checkbox>
          </form-row>
        </div>
      </section>
      <section>
        <h2>
          P
          <sub>AV, E</sub>
          - Überwachung
        </h2>
        <div class="group">
          <form-row>
            <label id="pMonitoringExists">
              P
              <sub>AV, E</sub>
              - Überwachung vorhanden:
            </label>
            <mat-error
              *ngIf="
                !placeInForm.get('pMonitoringExists').valid && placeInForm.get('pMonitoringExists').touched
              ">
              {{ errorOptionRequired }}
            </mat-error>
          </form-row>
          <form-row>
            <mat-radio-group
              aria-labelledby="pMonitoringExists"
              class="radio-group"
              fxLayout="row"
              fxLayoutGap="2em"
              formControlName="pMonitoringExists"
              (change)="setValidatorsMonitoring()">
              <mat-radio-button class="radio-button" [value]="true">Ja</mat-radio-button>
              <mat-radio-button class="radio-button" [value]="false">Nein</mat-radio-button>
            </mat-radio-group>
          </form-row>
        </div>

        <form-row>
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>
              Eingestellte Wirkleistung P
              <sub>AV,E</sub>
              in kW
            </mat-label>
            <input matInput type="number" formControlName="effectivePave" />
          </mat-form-field>
        </form-row>

        <form-row
          *ngIf="placeInForm.get('pMonitoringExists') && placeInForm.get('pMonitoringExists').value == true">
          <mat-checkbox formControlName="paveTestDone">
            Funktionstest P
            <sub>AV,E</sub>
            - Überwachung erfolgreich durchgeführt?
            <mat-error
              *ngIf="!placeInForm.get('paveTestDone').valid && placeInForm.get('paveTestDone').touched">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>
      </section>
      <section>
        <h2>Technische Einrichtung zur Reduzierung der Einspeiseleistung</h2>
        <section>
          <form-row>
            <app-feedin-management-summary
              [companyLocation]="model.companyLocation"
              [feedInManagementInfo]="model.feedInManagementInfo"
              [totalPower]="model.newInstalledPower || model.newProduction"
              [producers]="model.producers"
              [pvModules]="model.pvModules"></app-feedin-management-summary>
          </form-row>
        </section>
        <section *ngIf="feedInManagementFieldsRequired">
          <form-row>
            <mat-checkbox formControlName="eegConfirmation">
              Ich / Wir bestätigen, dass die Vorgaben gemäß §9 Erneuerbare-Energien-Gesetz (EEG) unter
              Berücksichtigung der "Technische Vorgaben" für das Einspeisermanagement bei EEG-Anlagen
              entsprechend umgesetzt wurde.
              <mat-error
                *ngIf="
                  !placeInForm.get('eegConfirmation').valid && placeInForm.get('eegConfirmation').touched
                ">
                {{ errorCheckRequired }}
              </mat-error>
            </mat-checkbox>
          </form-row>
          <form-row>
            <mat-checkbox formControlName="flawlessFunctionGuarantee">
              Die einwandfreie Funktion der Steuereinrichtung wird gewährleistet. Der Anlagenbetreiber
              verpflichtet sich, die Einrichtung stets in technisch einwandfreiem Zustand zu halten.
              <mat-error
                *ngIf="
                  !placeInForm.get('flawlessFunctionGuarantee').valid &&
                  placeInForm.get('flawlessFunctionGuarantee').touched
                ">
                {{ errorCheckRequired }}
              </mat-error>
            </mat-checkbox>
          </form-row>
        </section>
      </section>

      <section>
        <h2>Symmetriebedingung</h2>

        <div class="group">
          <form-row>
            <label id="symmetryConditions">Die Symmetriebedingung wird eingehalten...</label>
            <mat-error
              *ngIf="
                !placeInForm.get('symmetryConditions').valid && placeInForm.get('symmetryConditions').touched
              ">
              {{ errorOptionRequired }}
            </mat-error>
          </form-row>
          <form-row>
            <mat-radio-group
              aria-labelledby="symmetryConditions"
              class="radio-group radio-group--vertical"
              fxLayoutGap="2em"
              formControlName="symmetryConditions"
              (change)="setSymmetryConditionsMonitoring()">
              <mat-radio-button class="radio-button" [value]="symmetryConditionsEnum.ThreePhase">
                durch einen Drehstromgenerator oder einen dreiphasigen Umrichter.
              </mat-radio-button>
              <mat-radio-button class="radio-button" [value]="symmetryConditionsEnum.DeviceBalancing">
                durch eine Symmetrieeinrichtung, die den Unsymmetriewert auf 4,6kVA je Außenleiter begrenzt.
              </mat-radio-button>
              <mat-radio-button class="radio-button" [value]="symmetryConditionsEnum.SinglePhaseDistribution">
                durch folgende Aufteilung der einphasig angeschlossenen Erzeugungseinheiten je Außenleiter.
              </mat-radio-button>
            </mat-radio-group>
          </form-row>
        </div>

        <div
          class="group"
          *ngIf="
            placeInForm.get('symmetryConditions') &&
            placeInForm.get('symmetryConditions').value == symmetryConditionsEnum.SinglePhaseDistribution
          ">
          <div class="group">
            <h4>
              Summe S
              <sub>Emax</sub>
              &nbsp;der neu hinzukommenden Erzeugungsanlagen/Speicher *
            </h4>
            <form-row>
              <div fxFlex>
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>L1 - in kVA</mat-label>
                  <input matInput type="number" formControlName="addedGenerationL1" />
                  <mat-error *ngIf="placeInForm.get('addedGenerationL1').hasError('required')">
                    {{ errorFieldRequired }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex>
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>L2 - in kVA</mat-label>
                  <input matInput type="number" formControlName="addedGenerationL2" />
                  <mat-error *ngIf="placeInForm.get('addedGenerationL2').hasError('required')">
                    {{ errorFieldRequired }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex>
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>L3 - in kVA</mat-label>
                  <input matInput type="number" formControlName="addedGenerationL3" />
                  <mat-error *ngIf="placeInForm.get('addedGenerationL3').hasError('required')">
                    {{ errorFieldRequired }}
                  </mat-error>
                </mat-form-field>
              </div>
            </form-row>
          </div>

          <div class="group">
            <h4>
              Summe S
              <sub>Emax</sub>
              &nbsp;der ggf. vorhandenen Erzeugungsanlagen/Speicher
            </h4>
            <form-row>
              <div fxFlex>
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>L1 - in kVA</mat-label>
                  <input matInput type="number" formControlName="existingGenerationL1" />
                </mat-form-field>
              </div>
              <div fxFlex>
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>L2 - in kVA</mat-label>
                  <input matInput type="number" formControlName="existingGenerationL2" />
                </mat-form-field>
              </div>
              <div fxFlex>
                <mat-form-field appearance="outline" fxFlex>
                  <mat-label>L3 - in kVA</mat-label>
                  <input matInput type="number" formControlName="existingGenerationL3" />
                </mat-form-field>
              </div>
            </form-row>
          </div>
        </div>
      </section>
      <section>
        <h2>Datum der EEG-Technischen Inbetriebnahme</h2>
        <form-row>
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Datum der Inbetriebnahme</mat-label>
            <input matInput formControlName="placeInServiceDatum" [matDatepicker]="placeInServiceDatum" />
            <mat-datepicker-toggle matSuffix [for]="placeInServiceDatum"></mat-datepicker-toggle>
            <mat-datepicker #placeInServiceDatum></mat-datepicker>
            <mat-error
              *ngIf="
                placeInForm.get('placeInServiceDatum').hasError('required') &&
                placeInForm.get('placeInServiceDatum').touched
              ">
              {{ errorFieldRequired }}
            </mat-error>
            <mat-hint
              *ngIf="placeInServiceDatumMastrWarning$ | async as mastrDatumWarning"
              class="text-warning gr-place-in-service-datum-mastr-warning">
              {{ mastrDatumWarning }}
            </mat-hint>
          </mat-form-field>
        </form-row>
      </section>
      <section>
        <h2>Vollmacht</h2>
        <form-row>
          <mat-checkbox formControlName="customerAuthorization">
            Eine Vollmacht des Kunden liegt vor.
          </mat-checkbox>
        </form-row>
      </section>
      <section>
        <h2>Abschluss</h2>
        <form-row>
          <mat-checkbox formControlName="vdeConditions">
            Die Erzeugungsanlage und/oder der Speicher ist/sind nach VDE-AR-N 4105, VDE-AR-N 4100 und den
            technischen Anschlussbedingungen des Netzbetreibers errichtet.
            <br />
            Der Anlagenerrichter hat den Anlagenbetreiber einzuweisen und eine vollständige Dokumentation
            inkl. Schaltplan nach den jeweils gültigen VDE-Bestimmungen zu übergeben.
            <mat-error
              *ngIf="!placeInForm.get('vdeConditions').valid && placeInForm.get('vdeConditions').touched">
              {{ errorCheckRequired }}
            </mat-error>
          </mat-checkbox>
        </form-row>
      </section>
    </form>
  </app-default-card>
</div>

<section>
  <mat-error
    *ngIf="(errorFormList && !!errorFormList.length) || (mastrMismatchFields && !!mastrMismatchFields.length)"
    class="wrapper"
    style="text-align: right">
    <strong>Bitte beheben Sie die Fehler im Formular</strong>
  </mat-error>

  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
    <button
      *ngIf="mastrValidationActive$ | async"
      mat-raised-button
      color="primary"
      id="modal-confirm-button"
      (click)="confirm(!!mastrMismatchFields.length)">
      Inbetriebsetzungsprotokoll absenden
    </button>
    <button
      *ngIf="!(mastrValidationActive$ | async)"
      mat-raised-button
      color="primary"
      id="modal-confirm-button"
      (click)="confirm(false)">
      Inbetriebsetzungsprotokoll absenden
    </button>
  </div>
</section>
